/**
* Nom : companyList.js
* Description : Ce fichier contient la définition de la page companyList 
*               Cette page liste les sociétés clientes d'Asclepios Tech
* Date de création : 7 juillet 2025
*/

/* CSS et assets */
import { EditIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { AddItem } from 'package_ui_ihm/dist'
import { TextFilter } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react';
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'
import { useNavigate } from 'react-router-dom'


/**
* CompanyList : affiche la page qui liste les sociétés
*               filtrage de la liste possible sur le nom de la société
*               un lien permet d'afficher la page avec le formulaire pour créer une nouvelle société
*               pour chaque société une icone permet de l'editer 
*
* Type : page 
*
* Parametres : 
*  None
*/
function CompanyList() {

  // Define useState hooks

  const [companies, setCompanies] = useState([])
  const [statusCompanies, setStatusCompanies] = useState(null)
  const [isDataLoading, setDataLoading] = useState(false)
  const [selectedCompany, setSelectedCompany] = useState('');
  const [filteredCompanies, setFilteredCompanies] = useState([]);


  // Define useContext hooks
  const { authStatus, authToken, currentUser } = useAuth();
  const { path } = useApi();

  const navigate = useNavigate();


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define functions
  function updateFilteredCompanies() {
    // Filtering of companies by name
    if( selectedCompany !== "" )
    {
      setFilteredCompanies(companies.filter((company) => company.name.toLowerCase().includes(selectedCompany.toLowerCase())))
    }  
    else
    {
      setFilteredCompanies(companies)
    }
  }

  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // Companies
    const response = await fetch(path + "/api/au-cony/", 
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const data = await response.json();
    setStatusCompanies(response["status"])
    const company_list = data["results"]
    setCompanies(company_list)
    // Dataloading
    setDataLoading(false)
  }

  const handleIcon = (event, id) => {
    event.preventDefault();
    const target_path = '/companies/' + id + "/edit"
    navigate(target_path)
  };

  function formatAddress(company) {
    return company['address'] + ' ' + company['code'] + ' ' + company['city'] + ', ' + company['country']
  }

  const filterReset = (event) => {
      event.preventDefault();
      setFilteredCompanies(companies)
      setSelectedCompany("")
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    updateFilteredCompanies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, selectedCompany])


  // Render component
  return (
    <div>
      <TabC tabNumber={5}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusCompanies === 200) ? (
              <div>
                <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                  {/*Normal size of screen*/}
                    {/*Filtering*/}
                    <div className='flex-rows'>
                      { (currentUser["role_name"] === "AT_ADMIN") ? (
                        <AddItem path='/companies/new'>Ajouter une société</AddItem>
                      ) : (
                        null
                      )}
                      <h3>Filtres</h3>
                      <TextFilter label="Name" value={selectedCompany} setValue={setSelectedCompany}></TextFilter>
                      <div>
                        <button onClick={filterReset} className='button-secondary clickable'>Sans filtres</button>
                      </div>
                    </div>
                  {(screenWidth > 650) ? null : <Divider/>}
                  {/*Companies list*/}
                  <div className='scroll-list-c'>
                    <h2 className='subtitle'>Nombre de sociétés : {filteredCompanies.length}</h2>
                    {(filteredCompanies && filteredCompanies.length !== 0) ? (
                      filteredCompanies.sort((a, b) => (a.name > b.name)?1:-1).map((company) => (
                        <Item key={company['id']} id={company['id']}>
                          <div>
                            <div className='grid-1-1'>
                              <h3 className='item-text'>{company['name']}</h3> 
                              <div className='flex-row justify-end'>
                                { (currentUser["role_name"] === "AT_ADMIN") ? (
                                      <img src={EditIcon} alt='edit_item_icon' onClick={(e) => handleIcon(e, company['id']) } className='link-img'/>
                                    ) : (
                                      <p/>
                                    )
                                }
                              </div>
                            </div>
                            <div>
                              <p className='item-text'>Adresse : {formatAddress(company)}</p> 
                            </div>
                          </div>
                        </Item>
                      ))
                    ) : (
                      <p>Aucune société actuellement. Veuillez en créer une !</p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <h1>Connexion failed</h1>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default CompanyList;
